// extracted by mini-css-extract-plugin
export default {"zoomModal":"j1-z"};